const firebaseConfig = {
    apiKey: "AIzaSyCKke9rjw43pH0iy8TVastiDd0ZpChANL0",
    authDomain: "chatbot-demo-d9d72.firebaseapp.com",
    databaseURL: "https://chatbot-demo-d9d72.firebaseio.com",
    projectId: "chatbot-demo-d9d72",
    storageBucket: "chatbot-demo-d9d72.appspot.com",
    messagingSenderId: "76191162073",
    appId: "1:76191162073:web:2230f64200e157a45e68c8"
  };

  export default firebaseConfig